import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch } from 'react-redux';
import {
    Box,
    Grid,
    styled,
    Typography,
    Stack,
    Button,
    CircularProgress,
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import React, { useEffect, useState } from 'react';
import sendNotification from '../../utils/sendNotification';
import AutoSuggestSchool from '../BasicComponents/AutoSuggestSchool';
import { addNetworkInvitees } from '../../redux/SchoolSlice';
import axios from 'axios';
import ProfilePanel from '../BasicComponents/ProfilePanel';

const BookingButton = styled(LoadingButton)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px auto',
    width: '100%',
    maxWidth: '200px',
}));

export const NetworkSchoolInvite = props => {
    const dispatch = useDispatch();
    const { getAccessTokenSilently } = useAuth0();
    const [loading, setLoading] = useState(false);
    const [loadSchool, setLoadSchool] = useState(false);
    const [listItem, setListItem] = useState([]);
    const [sendRequestDisabled, setSendRequestDisabled] = useState(true);
    const [count, setCount] = useState(0);
    const [checkAll, setCheckAll] = useState(true);

    const sendInvites = async () => {
        setLoading(true);

        try {
            const requestList = listItem
                .filter(list => list.check === true)
                .map(list => ({
                    id: list.pk1,
                    schoolLogo: list.schoolLogo,
                    displayName: list.displayName,
                }));

            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });

            const requestData = {
                token,
                request: {
                    networkName: props.network?.network['gs1-pk'],
                    invitationType: 'school',
                    requestNetwork: false,
                    requestList,
                    invitedBySchool: props.pk1,
                },
            };

            const result = await dispatch(addNetworkInvitees(requestData));

            if (result.type === 'school/addNetworkInvitees/fulfilled') {
                console.log('request send');
                setListItem([]);
                setCount(0);
                setSendRequestDisabled(false);
                sendNotification('success', 3000, 'Network request sent');
            } else {
                sendNotification('error', 6000, 'Failed to send request');
            }

            // console.log(result);
        } finally {
            setLoading(false);
        }
    };

    const searchSchool = async school => {
        setLoadSchool(true);

        const schoolData = [school].map(data => ({
            ...data,
            inviteOtherSchool: true,
            sk1: 'school_',
            profileImage: data.schoolLogo,
            network: { status: '' },
            networkRequest: undefined,
            networkInvitation: 'null',
            check: false,
        }));

        setCount(0);

        // const networkName = props.network.network['gs1-pk'];
        const schoolId = school.pk1;

        const token = await getAccessTokenSilently({
            scope: process.env.REACT_APP_scope,
        });

        try {
            const result = await axios.get('/getSchoolList', {
                baseURL: process.env.REACT_APP_API_GATEWAY,
                timeout: 30000,
                headers: {
                    authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                params: {
                    search: schoolId,
                    exact: true,
                },
            });

            const res = result.data.schools.Message.Data;
            console.log('res', res.length);
            if (res.length > 0) {
                const ifInvited = res.filter(
                    item => item['gs1-pk'] === props.network.network['gs1-pk']
                );
                const acceptedNetwork = res.filter(
                    item =>
                        item['gs1-pk'] !== props.network.network['gs1-pk'] &&
                        item.networkInvitation === 'accepted'
                );

                const updatedSchoolData = schoolData.map(data => ({
                    ...data,
                    schoolNetwork: acceptedNetwork.length > 0,
                    networkInvitation:
                        ifInvited.length > 0
                            ? ifInvited[0].networkInvitation
                            : acceptedNetwork.length > 0
                            ? acceptedNetwork[0].networkInvitation
                            : 'null',
                    status:
                        ifInvited.length > 0
                            ? ifInvited[0].networkInvitation
                            : acceptedNetwork.length > 0
                            ? acceptedNetwork[0].networkInvitation
                            : 'null',

                    sk1:
                        ifInvited.length > 0 && ifInvited[0].sk1
                            ? ifInvited[0].sk1
                            : 'school_',
                }));

                setListItem(updatedSchoolData);
            } else {
                setListItem(schoolData);
            }
        } catch (err) {
            sendNotification('error', 6000, 'Failed to send request');
            console.log('catch block entered', err);
        } finally {
            setLoadSchool(false);
            console.log('Finally block');
        }
    };

    useEffect(() => {
        setSendRequestDisabled(count === 0);
    }, [count]);

    const selectAll = checkAll => {
        const updatedList = listItem.map(item => ({
            ...item,
            check: checkAll && item.networkInvitation === 'null',
        }));

        setCheckAll(checkAll);
        setListItem(updatedList);
        setCount(updatedList.filter(item => item.check).length);
    };

    const select = (index, value) => {
        const updatedList = [...listItem];
        updatedList[index].check = !value;

        const counts = updatedList.filter(item => item.check).length;
        const checkCount = updatedList.filter(
            item => typeof item.network === 'undefined'
        ).length;

        setCheckAll(counts === checkCount);
        setListItem(updatedList);
        setCount(counts);
    };

    return (
        <Grid container>
            <Typography variant="h5" sx={{ margin: '10px 4px' }}>
                Invite another school to join your network
            </Typography>

            <Grid item xs={12}>
                <Grid container alignItems="center" width="97%">
                    <Grid item xs={12}>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="flex-end"
                            gap={5}
                        >
                            <Typography variant="subtitle2">
                                Selected ( {count} )
                            </Typography>
                            <Button
                                variant="text"
                                size="medium"
                                onClick={() => selectAll(!checkAll)}
                            >
                                Select All
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={12}>
                <AutoSuggestSchool searchSchool={searchSchool} />

                {listItem.length > 0 && (
                    <Stack spacing={1} sx={{ padding: '14px 10px' }}>
                        {listItem.map((netItem, index) => (
                            <div key={index}>
                                {loadSchool ? (
                                    <CircularProgress
                                        sx={{
                                            height: 25,
                                            borderRadius: 2,
                                            margin: '0 auto',
                                        }}
                                    />
                                ) : (
                                    <ProfilePanel
                                        key={index}
                                        id={index}
                                        data={netItem}
                                        select={select}
                                    />
                                )}
                            </div>
                        ))}
                    </Stack>
                )}

                {props.network.networkItems?.length > 0 && (
                    <>
                        <hr style={{ width: '97%', marginLeft: '0px' }} />
                        <Typography variant="h5" sx={{ textAlign: 'left' }}>
                            Schools in Network
                        </Typography>
                        <Stack spacing={1} sx={{ padding: '14px 10px' }}>
                            {props.network.networkItems.map((data, index) => {
                                if (
                                    data.sk1.startsWith('school_') &&
                                    data.status !== 'rejected'
                                ) {
                                    return (
                                        //To Do: PK1 is encrypted so the school name cannot be displayed. Either send it unencrypted if it is a type school, or store more data in the invite record to show the data in this component
                                        //To Do: The component needs to be smart enough to know the difference between a teacher or school
                                        <ProfilePanel
                                            key={index}
                                            id={index}
                                            data={data}
                                            select={select}
                                        />
                                    );
                                }
                            })}
                        </Stack>
                    </>
                )}
            </Grid>

            <Grid item xs={12} textAlign="center">
                <BookingButton
                    size="small"
                    onClick={sendInvites}
                    loading={loading}
                    disabled={sendRequestDisabled}
                    variant="contained"
                >
                    Send
                </BookingButton>
            </Grid>
        </Grid>
    );
};

export default NetworkSchoolInvite;
